<template>
    <div class="pt-8">
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Address & Contact Options</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl px-3 pb-4 pt-1">
            <div v-if="addresses.length" class="text-sm">
                <div v-for="(addressData,index) in addresses" class="mb-1 mt-3 py-1 border-b border-gray-300">
                    <div class="flex">
                        <label class="flex-grow">Address:</label>
                        <div class="flex-shrink relative" v-if="false">
                            <ui-button-new v-if="editing!==index" small extra class="absolute top top-0 -mt-2"
                                           @click.prevent="editing=index">Edit
                            </ui-button-new>
                            <ui-button-new v-else small extra class="absolute top top-0 -mt-2" @click.prevent="editing=false">
                                Done
                            </ui-button-new>
                        </div>
                    </div>
                    <div v-if="editing!==index"
                         class="rounded-md border border-gray-50 text-sm mb-1 p-1 whitespace-pre-wrap"
                         v-text="addressData.address"></div>
                    <textarea-autosize class="rounded-md border border-gray-300 text-sm mt-0 mb-1 px-1 py-1"
                                       v-model="addressData.address" rows="3" ref="address"
                                       @input="$emit('input', addressData)" v-else
                    >
                    </textarea-autosize>
                    <div class="flex">
                        <div class="flex-1 mr-1">
                            <label>Contact Name:</label>
                            <div v-if="editing!==index" class="rounded-md border border-gray-50 text-sm m-0 p-1 my-1"
                                 v-text="addressData.contactName"></div>
                            <input class="rounded-md border border-gray-300 text-sm m-0"
                                   v-model="addressData.contactName"
                                   @input="$emit('input', addressData)" v-else>
                        </div>
                        <div class="flex-1 ml-1">
                            <label>Contact Phone:</label>
                            <div v-if="editing!==index" class="rounded-md border border-gray-50 text-sm m-0 p-1 my-1"
                                 v-text="addressData.contactNumber"></div>
                            <input class="rounded-md border border-gray-300 text-sm m-0"
                                   v-model="addressData.contactNumber"
                                   @input="$emit('input', addressData)" v-else>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-2" v-else>No address/contacts are in use</div>
        </div>
    </div>
</template>

<script>

import moment from "moment";
import UiButtonNew from "../../ui/UiButtonNew.vue";

export default {
    components: {UiButtonNew},
    props: {
        addresses: Array,
        readonly: Boolean,
    },
    watch: {},
    data() {
        return {
            moment,
            editing: false,
        }
    },
    methods: {
        edit(index) {
            this.editing = index
            this.$nextTick(() => {
                this.$refs.address[0].$el.focus()
            })

        }
    },
    mounted() {
    }
}
</script>
